import React,{Component} from 'react';
import { Route, Switch } from 'react-router-dom';
import { connect } from "react-redux"
import { bindActionCreators } from "redux";

import querystring from 'querystring'
import { WithContext as ReactTags } from 'react-tag-input';
import "../../../template/custom/react-tags.css";

import *as config from '../../../config'
import * as dashboardSummaryActions from "../../../actions/dashboardSummaryActions";
import EditableText from '../../Shared/EditableText'
import Spinner from "../../Shared/Spinner";
import AdminMenu from "../../Shared/SideBar/AdminMenu";

class Summary extends Component{
    constructor(props){
        super(props)   

        let {dashboardSummaryActions} = this.props;
        dashboardSummaryActions.GetSummary();
    }    
    render(){
        let{summary} = this.props;              
        return(
            <div>                
                <div className="table-wrapp">
                    <div className="datatable-header">
                            {
                                summary.data.length > 0 ?
                                summary.data.map((summary,index) => {
                                        let key = index
                                        return(
                                            <div>
                                                <p><span>Сделано связок за сегодня: </span>{summary.periodCount}</p>
                                                <p><span>Всего связок: </span>{summary.totalCount}</p>
                                            </div>
                                        )
                                    })
                                    : summary.set ?
                                    <p>
                                        Нет данных                                        
                                    </p>
                                    :null
                            }
                    </div>                    
                </div>
            </div>                
        );
    }
}

function mapStateToProps(state) {
    return {
        summary: state.summary
    }
}

function mapDispatchToProps(dispath) {
    return {
        dashboardSummaryActions: bindActionCreators(dashboardSummaryActions, dispath),
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(Summary);


// WEBPACK FOOTER //
// ./src/components/Dashboard/Summary/index.jsx